import React, { useEffect } from 'react';
import "../Components/Menusectionpage.css";
import searchCar from "../Components/images/icons8-search-64.png";
import Car from "../Components/images/icons8-car-100.png";
import rideCar from "../Components/images/icons9-car-100.png";
import confirmRide from "../Components/images/icons8-cash-48.png";
import { useState } from 'react';
import support from "../Components/images/icons8-24-hours-day-support-100.png";
import driver from "../Components/images/icons8-driver-80.png";
import payment from "../Components/images/icons8-payment-48.png";
import booking from "../Components/images/icons8-booking-50.png";
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase-config';

const Menusectionpage = () => {
  const [reviewservices, sethServices] = useState([]);
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", "Reviews")
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        sethServices(data);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);

  const Taxidata = [
    {
      icon: support,
      title: "24/7 Customer Support",
    },
    {
      icon: driver,
      title: "Verified Drivers",
    },
    {
      icon: payment,
      title: "Secure Payment",
    },
    {
      icon: booking,
      title: "Easy Booking",
    },
  ];
  const reviews = [
    {
      name: "Ahmed Khan",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
      rating: 5,
      description: "Very professional drivers and clean cars. Highly recommended for airport transfers!"
    },
    {
      name: "Fahad Ali",
      image: "https://randomuser.me/api/portraits/men/45.jpg",
      rating: 4,
      description: "Booking was very easy and support team responded quickly. Great service!"
    },
    {
      name: "Mohammed Rizwan",
      image: "https://randomuser.me/api/portraits/men/12.jpg",
      rating: 5,
      description: "Best taxi service in Jeddah. Safe, reliable and affordable pricing."
    },
    {
      name: "Mohammed Rizwan",
      image: "https://randomuser.me/api/portraits/men/12.jpg",
      rating: 5,
      description: "Best taxi service in Jeddah. Safe, reliable and affordable pricing."
    },
    {
      name: "Mohammed Rizwan",
      image: "https://randomuser.me/api/portraits/men/12.jpg",
      rating: 5,
      description: "Best taxi service in Jeddah. Safe, reliable and affordable pricing."
    }
  ];
  const steps = [
    {
      icon: searchCar,
      title: "Search Car",
      desc: "Search for nearby cabs, set your route, and book a ride in just a few taps."
    },
    {
      icon: Car,
      title: "Choose Car",
      desc: "Choose your own cab, driver, and payment option for a smooth ride."
    },
    {
      icon: rideCar,
      title: "Enjoy the Ride",
      desc: "Track your ride in real-time and enjoy a smooth, stress-free journey."
    },
    {
      icon: confirmRide,
      title: "Confirm & Pay",
      desc: "Confirm your booking and pay securely using your preferred payment method."
    }
  ];


  const bookingFaq = [
    {
      q: "How Can I Book a Car with MAS ?",
      a: "You can easily book your ride through our website, WhatsApp, or by contacting our customer support team for instant confirmation."
    },
    {
      q: "Can I Receive Booking Confirmation?",
      a: "Yes, once your booking is completed, you will receive confirmation details including driver information and vehicle details."
    },
    {
      q: "Can I Schedule a Ride in Advance?",
      a: "Yes, MAS allows advance bookings to ensure vehicle availability for airport transfers, events, or business travel."
    },
    {
      q: "Is Last-Minute Booking Available?",
      a: "Yes, depending on vehicle availability, we accept urgent and same-day bookings across Jeddah."
    },
    {
      q: "Can I Modify or Cancel My Booking?",
      a: "Yes, bookings can be modified or cancelled by contacting our support team prior to the scheduled pickup time."
    },
    {
      q: "Do You Provide Chauffeur Services?",
      a: "Yes, professional chauffeur-driven vehicles are available for business trips, city rides, and special occasions."
    },
    {
      q: "Can I Book Vehicles for Long Trips?",
      a: "Yes, MAS provides city-to-city transfers and long-distance travel services with comfortable vehicles."
    }
  ];

  const paymentFaq = [
    {
      q: "What Payment Methods Are Accepted?",
      a: "We accept cash payments, bank transfers, UPI, and secure online payment options for customer convenience."
    },
    {
      q: "Do I Need to Pay in Advance?",
      a: "Advance payment may be required for long-distance trips or event transportation bookings."
    },
    {
      q: "Will I Receive an Invoice After Payment?",
      a: "Yes, MAS provides a digital invoice or payment receipt after completion of your journey."
    },
    {
      q: "Are There Any Hidden Charges?",
      a: "No, we follow transparent pricing policies with no hidden costs. The confirmed price is final."
    },
    {
      q: "Can Corporate Clients Use Monthly Billing?",
      a: "Yes, corporate customers can opt for monthly billing and customized payment agreements."
    },
    {
      q: "Is Online Payment Secure?",
      a: "Yes, all online transactions are processed through secure and trusted payment gateways."
    },
    {
      q: "Can I Pay the Driver Directly?",
      a: "Yes, customers can choose to pay directly to the driver using cash or approved digital payment methods."
    }
  ];

  const [activeTab, setActiveTab] = useState("booking");
  const [open, setOpen] = useState(null);
  const data = activeTab === "booking"
    ? bookingFaq
    : paymentFaq;

  const displayData =
    reviewservices.length > 0 ? reviewservices : reviews;
  return (
    <div>
      <br />

      <section className="faq-section">

        <h2 className="section-title">
          <div className="services-vertical-line"></div> &nbsp;
          Frequently Asked Questions
        </h2>

        {/* ✅ TOP TABS */}
        <div className="faq-tabs">
          <button
            className={activeTab === "booking" ? "active" : ""}
            onClick={() => setActiveTab("booking")}
          >
            Bookings
          </button>

          <button
            className={activeTab === "payment" ? "active" : ""}
            onClick={() => setActiveTab("payment")}
          >
            Payments
          </button>
        </div>

        {/* ✅ FAQ LIST */}
        <div className="faq-container">
          {data?.map((item, i) => (
            <div className="faq-item" key={i}>
              <div
                className="faq-question"
                onClick={() => setOpen(open === i ? null : i)}
              >
                {item?.q}
                <span>{open === i ? "-" : "+"}</span>
              </div>

              {open === i && (
                <div className="faq-answer">{item?.a}</div>
              )}
            </div>
          ))}
        </div>

      </section>
      <br />
      <section className="works-section">
        <h2 className="section-title">
          <div className="services-vertical-line"></div> &nbsp; &nbsp;How It Works?
        </h2>

        <div className="works-container">
          {steps?.map((step, index) => (
            <div className="work-card" key={index}>
              <div className="icon-circle">
                <img src={step?.icon} alt={step?.title} />
              </div>
              <h3 className="work-title">{step?.title}</h3>
              <p className="work-desc">{step?.desc}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="unique-section">
        <h2 className="section-title">
          <div className="services-vertical-line"></div> &nbsp;
          What Makes MAS Taxi Unique?
        </h2>
        <div className="unique-container">
          {Taxidata?.map((item, index) => (
            <div key={index} className="unique-card">
              <div className="icon-circle">
                <img src={item?.icon} alt={item?.title} />
              </div>
              <p className="unique-text">{item?.title}</p>
            </div>
          ))}
        </div>
      </section>
      <br />
      <section className="review-section">
        <h2 className="section-title">
          <div className="services-vertical-line"></div> &nbsp;
          What Our Customers Say
        </h2>
        <div className="review-container">
          {displayData?.map((review, index) => (
            <div className="review-card" key={index}>
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <span
                    key={i}
                    className={`star ${i < review?.rating ? "filled" : ""}`}
                  >
                    ★
                  </span>
                ))}
              </div>
              <p className="review-text">"{review?.description}"</p>
              <div className="reviewer">
                <img src={review?.image} alt={review?.image} />
                <span>{review?.name}</span>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Menusectionpage
